import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import MakePayment from "./MakePayment";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";

const ConfirmPaymentModel = () => {
  const [show, setShow] = useState(
    localStorage.getItem("makePay") ? true : false
  );

  const [showPayment, setShowPayment] = useState(false);
  const user=localStorage.getItem('data');
  
  const Razorpay = useRazorpay();
  const makePayment = useCallback(() => {
    setShow(false);
    localStorage.removeItem("makePay");
    const amount = 10 * 100;
    const options = {
      key: "rzp_live_LBhcmmFsc8Hnor",
      amount: amount,
      currency: "INR",
      name: "Educloudlabs",
      description: "Buy Courses & Certification",
      image: "https://example.com/your_logo",

      handler: (res) => {
        console.log(res);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  }, [Razorpay]);

  const handleClose = () => {
    setShow(false);
    localStorage.removeItem("makePay");
  };

  return (
    <div>
      {showPayment && <MakePayment />}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title
            className={"color-white"}
            style={{ color: "aliceblue", fontWeight: 700 }}
          >
            Payment Confim
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="err-model-body">
          <div className="form-group">
            <label className="mont-font fw-600 font-xsss color-white">
              Are you sure want to make continue payment?
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="tr-popup-btn" onClick={() => makePayment()}>
            Yes
          </button>
          <button className="tr-popup-btn" onClick={() => handleClose()}>
            No
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmPaymentModel;
